const headerPk = {
	brand: 'گرامین بازار',
	top: {
		bazarList: 'بازار',
		help: 'مدد',
		contact: 'رابطہ',
	},
	nav: {
		dailyBazar: 'کریانہ',
		medicineBazar: 'ادویات',
		foodBazar: 'تازہ خوراک',
		grains: 'اناج',
		nationalBazar: 'قومی',
		garmentsBazar: 'کپڑے',
		cosmeticsBazar: 'کاسمیٹکس',
		bookBazar: 'کتابیں',
		nurseryBazar: 'نرسری',
		electronicsBazar: 'الیکٹرانکس',
		chemicalBazar: 'کیمیکل',
		hardwareBazar: 'ہارڈویئر',
		serviceBazar: 'سروس',
		feedBazar: 'جانوروں کی خوراک',
	},
	search: {
		placeholder: 'آپ کیا خریدنا چاہتے ہیں؟',
	},
	drawer: {
		home: 'ہوم',
		dailyBazar: 'ڈیلی بازار',
		medicineBazar: 'ادویات بازار',
		grains: 'اناج بازار',
		nationalBazar: 'قومی بازار',
		foodBazar: 'تازہ خوراک',
		bookBazar: 'کتابوں کا بازار',
		nurseryBazar: 'نرسری بازار',
		garmentsBazar: 'گارمنٹس بازار',
		electronicsBazar: 'الیکٹرانکس بازار',
		chemicalBazar: 'کیمیکل بازار',
		hardwareBazar: 'ہارڈویئر بازار',
		cosmeticsBazar: 'کاسمیٹکس بازار',
		serviceBazar: 'سروس بازار',
		feedBazar: 'فیڈ بازار',
	},
	profileMenu: {
		login: 'لاگ اِن',
		register: 'رجسٹر',
		myAccount: 'میرا اکاؤنٹ',
		storeDashboard: 'اسٹور ڈیش بورڈ',
		adminDashboard: 'ایڈمن ڈیش بورڈ',
	},
};

export default headerPk;


